<template>
  <b-card class="mb-0 responsive-card">
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">My Landowner Reports</h5>
    </b-form-row>
    <div>
    <b-dropdown :text="tabs[landownerReportTab].title" v-if="isMobile">
      <b-dropdown-item v-for="({ title, disabled }, index) in tabs" @click="landownerReportTab = index" :disabled="disabled">
        {{ title }}
      </b-dropdown-item>
    </b-dropdown>
    <b-tabs v-model="landownerReportTab" pills card active-nav-item-class="active-tab-nav">
      <b-tab title="Past Due" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''" active>
        <MyPastDueLandownerReports v-if="activeTabs.pastDue"/>
      </b-tab>
      <b-tab title="Not Started" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyNotStartedLandownerReports v-if="activeTabs.notStarted"/>
      </b-tab>
      <b-tab title="Started" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyDraftLandownerReports v-if="activeTabs.started"/>
      </b-tab>
      <b-tab title="Complete" :title-link-class="'tab-nav'" :title-item-class="isMobile ? 'd-none' : ''">
        <MyCompleteLandownerReports v-if="activeTabs.complete"/>
      </b-tab>
    </b-tabs>
  </div>
  </b-card>
</template>
<script>
import { mapState } from 'vuex';
import MyNotStartedLandownerReports from '@/components/dashboard/MyNotStartedLandownerReports.vue';
import MyDraftLandownerReports from '@/components/dashboard/MyDraftLandownerReports.vue';
import MyPastDueLandownerReports from '@/components/dashboard/MyPastDueLandownerReports.vue';
import MyCompleteLandownerReports from '@/components/dashboard/MyCompleteLandownerReports.vue';

export default {
  name: 'MyLandownerReports',
  components: {
    MyNotStartedLandownerReports,
    MyDraftLandownerReports,
    MyPastDueLandownerReports,
    MyCompleteLandownerReports,
  },
  computed: {
    ...mapState(['isExtraSmall']),
  },
  data() {
    return {
      landownerReportTab: 0,
      activeTabs: {
        pastDue: true,
        notStarted: false,
        started: false,
        complete: false,
      },
      tabs: [
        {
          title: 'Past Due',
        },
        {
          title: 'Not Started',
        },
        {
          title: 'Started',
        },
        {
          title: 'Complete',
        },
      ],
      isMobile: false,
    };
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        this.shiftMobile();
      } else {
        this.isMobile = false;
      }
    },
    landownerReportTab(newTab) {      
      const tabNames = [
        'pastDue', 
        'notStarted', 
        'started', 
        'complete'
      ];
      const tabName = tabNames[newTab];      
      if (!this.activeTabs[tabName]) {
        this.activeTabs[tabName] = true;
        // Add logic to load data for the tab if needed
      }
    },
  },
  methods: {
    shiftMobile() {
      this.isMobile = true;
    },
  },
  created() {
    if (this.isExtraSmall) {
      this.shiftMobile();
    }
  },
};
</script>
<style>
.active-tab-nav {
  border-radius: 1.25rem !important;
  color: #ffffff;
}
.tab-nav {
  color: #01893f;
}
</style>
